module.exports = __webpack_public_path__ + "static/media/NewOrleans.47bc8f28.jpg";